import { render, staticRenderFns } from "./AdminRootView.vue?vue&type=template&id=3fbb6690"
import script from "./AdminRootView.vue?vue&type=script&lang=js"
export * from "./AdminRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports